import React from 'react';
import ResultPanel, { replacement } from './Result';
import ButtonPanel from './Buttons';
import mathjs from 'math-expression-evaluator';
import { X } from 'react-feather';
import { toast, Bounce } from 'react-toastify';
// import '../Style/index.css'
// import '../Style/flex.css'

export default class Calculator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            last: '',
            cur: this?.props?.cur ? this.props.cur : '0',
            isClear: false,
        };
        this.onPaste = this.onPaste.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.setStateAndNotify = this.setStateAndNotify.bind(this);
        this.keyMap = {};
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.cur !== '') {
            this.setState({ cur: newProps.cur ? newProps.cur : '0' });
        }
    }

    onPaste = (event) => {
        if (event.isTrusted) {
            const data = event.clipboardData || window.clipboardData;
            const pastedData = data.getData('Text');
            let cur;
            replacement.forEach((item) => {
                cur = pastedData.replace(item.dist, item.reg);
            });
            try {
                const evaluate = new mathjs().eval(cur);
                this.setStateAndNotify({
                    cur: evaluate,
                    last: cur,
                });
            } catch (e) {
                this.setStateAndNotify({
                    cur,
                    last: 'Not a valid expression',
                });
            }
        }
    };

    setStateAndNotify = (newState) => {
        this.setState(
            newState,
            this.props.onResultChange
                ? this.props.onResultChange({
                      expression: newState.last,
                      result: newState.cur,
                  })
                : null,
        );
    };

    handleKeyDown(event) {
        let button;
        if (event.ctrlKey || event.keyCode === 67) {
            return;
        }
        const key = (event.shiftKey ? 'shift+' : '') + event.keyCode || event.which;
        if ((button = this.keyMap[key])) {
            button.click();
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onOkClick = () => {
        let Encode = /^(?!\s+$)[0-9.]+$/;
        if (Encode.test(this.state.cur)) {
            this.props.onOkClick(this.state.cur);
        } else {
            toast.error('Please add valid values', {
                transition: Bounce,
                position: toast.POSITION.TOP_CENTER,
            });
        }
    };

    onEraseClick = () => {
        this.props.onEraseClick();
    };

    handleState = (state, value) => {
        this.setState({ [state]: value });
    };

    onButtonClick(type) {
        let { cur } = this.state;
        if (this.state.isClear) {
            cur = '0';
            this.setState({ isClear: false });
        }
        const lastLetter = cur.slice(-1);
        switch (type) {
            case 'c':
                this.setStateAndNotify({
                    last: '',
                    cur: '0',
                });
                break;
            case 'back':
                this.setState({ cur: cur === '0' ? cur : cur.slice(0, -1) || '0' });
                break;
            case '=':
                try {
                    const evaluate = new mathjs().eval(cur).toString();
                    this.setStateAndNotify({
                        last: cur + '=',
                        cur: evaluate,
                    });
                } catch (e) {
                    this.setState({
                        last: cur + '=',
                        cur: '0',
                    });
                }
                break;
            case '+':
            case '-':
            case '*':
            case '/':
                if (Number(cur) === 0 && type === '-') {
                    this.setState({
                        cur: type,
                    });
                    break;
                }
                if ((lastLetter === '*' && type === '-') || (lastLetter === '/' && type === '-')) {
                    this.setState({
                        cur: cur + type,
                    });
                    break;
                }

                if (lastLetter === '+' || lastLetter === '-' || lastLetter === '*' || lastLetter === '/')
                    this.setState({
                        cur: cur.slice(0, -1) + type,
                    });
                else
                    this.setState({
                        cur: cur + type,
                    });
                break;
            case '.':
                if (lastLetter !== '.') {
                    this.setState({
                        cur: cur + type,
                    });
                }
                break;
            default:
                this.setState({
                    cur: cur === '0' ? type : cur + type,
                });
                break;
        }

        if (this.props.onNewInput) {
            this.props.onNewInput({ expression: this.state.cur, key: type });
        }
    }

    componentWillUnmount() {
        this.setState({
            last: '',
            cur: this?.props?.cur ? this.props.cur : '0',
            isClear: false,
        });
    }
    render() {
        return (
            <div
                id="Saurbhi-calculator"
                className="Saurbhi-calculator rounded"
                onPaste={this.onPaste}
                onKeyDown={this.handleKeyDown}
            >
                <div className="d-inline-block calculator-body">
                    <div className="calculator-header d-flex justify-content-between align-items-center">
                        <span className="calculator-header-title">Calculator</span>
                        <button className="btn btn-sm close-btn">
                            <X
                                size="14"
                                className="calc-white-icon"
                                strokeWidth="3"
                                onClick={() => {
                                    this.props.onClose();
                                }}
                            />
                        </button>
                    </div>
                    <ResultPanel
                        {...this.state}
                        noOfCartonWrapper={this.props.noOfCartonWrapper}
                        handleState={this.handleState}
                    />
                    <ButtonPanel
                        cur={this.state.cur}
                        noOfCartonWrapper={this.props.noOfCartonWrapper}
                        discountWrapper={this.props?.discountWrapper ? this.props?.discountWrapper : false}
                        onClick={this.onButtonClick}
                        onOkClick={this.onOkClick}
                        onEraseClick={this.onEraseClick}
                        onLoad={(keyMap) => {
                            this.keyMap = keyMap;
                        }}
                    />
                </div>
            </div>
        );
    }
}
